/**
 * Polyfills to support Edge 44 & IE 11
 */
import "isomorphic-fetch";
import "core-js/modules/es.array.from";
import "core-js/modules/es.reflect.delete-property";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.promise.all-settled";
import "./PromiseAllSettled";